import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  FormGroup, ControlLabel, FormControl, Form, Row, Col
} from 'react-bootstrap'
import { values, sortBy } from 'lodash'
import { Link } from 'react-router'

import { getReadyState, getSuppliers, getActivitiesPerSupplier } from '../selectors'
import { l } from '../../lib/Tools.js'
import isObjectEqual from '../../lib/isObjectEqual.js'
import { getText } from '../lib/text.js'

type Props = {
  ready: boolean,
  supplierId: string,
  onChange: string => void,
  suppliers: Object,

  inline: ?boolean,
  labelWidth: ?number,
  disabled: ?boolean
}

class SupplierSelector extends React.PureComponent
{
  props: Props

  render() {
    const { ready, supplierId, onChange, suppliers, labelWidth } = this.props
    if (!ready) return (<p>Loading...</p>)

    return (
      <Form inline={this.props.inline || false}>

        <FormGroup style={{ display: "block" }}>
          <ControlLabel
            style={labelWidth ? { width: labelWidth } : {}}
          >
            {getText("Proveedor habitual:")}
          </ControlLabel>
          <FormControl
            componentClass="select"
            value={supplierId}
            onChange={evt => onChange(evt.target.value == "" ? null : evt.target.value)}
            disabled={this.props.disabled}
            style={{maxWidth: 150}}
          >
            <option value= {""} >{`${getText("Sin proveedor")}`}</option>
            {
              sortBy(
                values(suppliers),
                o => o.name.toLowerCase()
              )
                .map(s => (<option value={s._id} key={s._id}> {s.name} </option>))
            }
          </FormControl>
          {
            supplierId && (
              <span style={{marginTop: 8, marginLeft: 8}}>
                <Link to={`/private/supplier/${encodeURIComponent(supplierId)}?`}>
                  {getText(`Ver proveedor`)}
                </Link>
              </span>
            )
          }
        </FormGroup>
      </Form>
    )
  }
}

SupplierSelector.defaultProps = {
  labelWidth: null
}

const mapStateToProps = (state, props) => ({
  suppliers: getSuppliers(state, props),
  suppliersActivities : getActivitiesPerSupplier(state, props),
  ready: getReadyState(state, props),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSelector)
